<template>
  <section class="users">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('USER', 2) }) | formatTitle"></vue-headful>
    <user-list></user-list>

    <router-view class="users__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import UserList from './UserList'

export default {
  name: 'users',
  components: { UserList }
}
</script>
